import { useEffect, useMemo, useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useLoading } from "../context/LoadingContext";

export default function GlobalLoadingOverlay() {
  const { isLoading } = useLoading();
  const [textIndex, setTextIndex] = useState(0);
  const [show, setShow] = useState(false);
  const showTimerRef = useRef(null);
  const hideTimerRef = useRef(null);
  const lastShownAtRef = useRef(0);

  const loadingTexts = useMemo(
    () => [
      "Software Systems Engineer",
      "ZenDev",
      "Systeme, die halten",
      "Build · Teach · Consult",
      "Schreiben. Bauen. Schaerfen.",
    ],
    []
  );

  useEffect(() => {
    if (!isLoading) return;
    const t = setInterval(() => {
      setTextIndex((i) => (i + 1) % loadingTexts.length);
    }, 1200);
    return () => clearInterval(t);
  }, [isLoading, loadingTexts.length]);

  useEffect(() => {
    const SHOW_DELAY = 200;
    const HIDE_DELAY = 600;

    if (isLoading) {
      if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
      if (!show && !showTimerRef.current) {
        showTimerRef.current = setTimeout(() => {
          showTimerRef.current = null;
          lastShownAtRef.current = Date.now();
          setShow(true);
        }, SHOW_DELAY);
      }
      return;
    }

    if (showTimerRef.current) {
      clearTimeout(showTimerRef.current);
      showTimerRef.current = null;
    }
    if (show) {
      hideTimerRef.current = setTimeout(() => {
        hideTimerRef.current = null;
        setShow(false);
      }, HIDE_DELAY);
    } else {
      setShow(false);
    }
  }, [isLoading, show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          key="global-loading-overlay"
          className="absolute inset-0 z-20 flex items-center justify-center bg-[#151515] pointer-events-none"
          initial={{ opacity: 1, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -12 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#AC8E66] font-mono">
            Denis Bitter |{" "}
            <span className="text-[#d0cbb8]/80">{loadingTexts[textIndex]}</span>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
